import { Component, OnInit, ViewChild } from '@angular/core';
import {  ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

import { GlobalService } from 'src/app/_services/global.service';

import { Router } from '@angular/router';
import { GridService } from 'src/app/_services/grid.service';

import { ApiService } from 'src/app/_services/api.service';
import { CheckboxRenderer } from  'src/app/components/grid-addons/checkbox-renderer/checkbox-renderer.component';

import {
  ColDef,
  CellEditingStartedEvent,
  GridReadyEvent,
} from 'ag-grid-community';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import * as moment from 'moment';

@Component({
  selector: 'app-checkl',
  templateUrl: './checkl.component.html',
  styleUrls: ['./checkl.component.css'],
  providers: [ MessageService,ConfirmationService]
})

export class ChecklComponent implements OnInit {

  struttureList:any[]=[];
  questionari: SelectItem[] = [];  
  strutturelistSelected:any[]=[];
  onlyLastCheckList:boolean=false;
  checkllist: any[] = [];
  allaDataSel:Date;
  dallaDataSel:Date;
  filtro={
    questionario:null
  };

  columns: ColDef[] = [
    { field: 'id',  
      headerName: '', 
      maxWidth:50,
      cellRenderer: params =>    {   
          if(typeof params.value == 'undefined')
            return '';
            return '<a title="'+'Modifica compilazione'+'"><i class="pointer pi pi-pencil"></i></a>'; 
      },
      onCellClicked:function(data){ 
          _this.router.navigate(['/dashboard/checklists/checkl-edit/update',data.data.id]);
      }   
    },
 
    
    { field: 'name',headerName: 'Questionario' },
    { field: 'modello',headerName: 'Modello' },
    { field: 'status',headerName: 'Stato compilazione' },
    { field: 'struttura',headerName: 'Struttura' },
    { field: 'date_lastmodify', headerName: 'Ultima modifica',valueFormatter: (data) => moment(data.value).format('DD/MM/YYYY HH:mm') },
    { field: 'id',  
      headerName: '', 
      maxWidth:50,
      cellRenderer: params =>    {   
          if(typeof params.value == 'undefined')
            return '';
          if(params.data.status != 'IN COMPILAZIONE')
            return '';
     
          return '<a title="'+'Elimina compilazione'+'"><i class="pointer pi pi-trash"></i></a>'; 
      },
      onCellClicked:function(params){ 
        if(params.data.status != 'IN COMPILAZIONE')
          return '';
        
      _this.confirmationService.confirm({
        message: 'Attenzione: si conferma la cancellazione?',
        accept: () => {
          _this.apiService.delCheckList({id:params.data.id}).subscribe(data => {
            _this.addSingle('success', 'Success', 'Questionario eliminato');
            _this.load();
          });
        }
      });
      }   
    },
  ];
  frameworkComponents = {
    checkboxRenderer: CheckboxRenderer
  }

  gridApi;
  defaultColDef = {
    width: 250,
    minWidth: 100,
    sortable:true,
    flex:1
  };

 
  
  defaultSortModel = [
    { colId: 'name', sort: 'asc', sortIndex: 0 },
  ];

 
  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    params.api.showLoadingOverlay();
    params.columnApi.applyColumnState({ state: this.defaultSortModel });
  }

  constructor(
    private router: Router,
    private messageService: MessageService,
    private translate: TranslateService,
    public globalService: GlobalService,
    public gridService: GridService,
    private apiService: ApiService,
    public confirmationService: ConfirmationService
  ) { }

  
  ngOnInit(): void {
    _this=this;
    const params: any = {PageSize : 10000};
    this.apiService.get('checklists/listall',params).subscribe(data => {
      data.Result.forEach((q)=>{
        this.questionari.push({
          label:q.name,value:q.id
        });
      });
      this.apiService.get('checklists/checkl_getstrutture',{}).subscribe(datastrutture => {
        this.struttureList=datastrutture.Result;
      });
      this.load();
    });
  
   
  }

  load(){
    let params:any= {id_user:this.globalService.loggedUser.id};
    if(this.dallaDataSel) {
      params.periodfrom=moment(this.dallaDataSel).format('YYYY-MM-DD');
    }
    if(this.allaDataSel) {
      params.periodto=moment(this.allaDataSel).format('YYYY-MM-DD');
    }

    params.questionario=this.filtro.questionario;
    params.strutture=this.strutturelistSelected;
    params.onlyLastCheckList=this.onlyLastCheckList;
    this.checkllist=[];
    this.apiService.get('checklists/checkl-listall',params).subscribe(data => {
      this.checkllist=data.Result;
    });
  
      
  }

  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }


}
var _this;